import React, { Component } from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Paper from '@material-ui/core/Paper';
import {
  TextField, PasswordField, Button, LoadingIndicator, ErrorMessage,
} from '../components';

const styles = theme => ({
  buttonStyle: {
    width: '100%',
    fontWeight: 'bold',
  },
  formGroupStyle: {
    width: '100%',
    textAlign: 'center',
    marginTop: 10,
  },
  logoStyle: {
    maxWidth: 300,
    width: '100%',
    textAlign: 'center',
  },
  containerStyle: {
    maxWidth: '300px',
    textAlign: 'center',
    padding: '15px 20px 20px 20px',
    backgroundColor: '#ffffffdb',
    borderRadius: '10px',
  },
  inputStyle: {
    width: '100%',
  },
  copyrightStyle: {
    marginTop: '10px',
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    color: '#e0e0e0',
  },
  link: {
    color: theme.palette.link.main,
  },
  textfield: {
    paddingLeft: '7px',
    paddingRight: '7px',
  },
});

class PictureLogin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userName: '',
      password: '',
    };
  }

  setUsername = (event) => {
    this.setState({ userName: event.target.value });
  }

  setPassword = (event) => {
    this.setState({ password: event.target.value });
  }

  keyPress = (event) => {
    if (event.key === 'Enter') {
      this.login();
      event.preventDefault();
      return false;
    }
    return true;
  }

  login = () => {
    const { login } = this.props;
    const { userName, password } = this.state;


    if (userName && userName !== '' && password && password !== '') {
      login({ userName, password });
    }
  }

  renderLoginButton = () => {
    const { isLoading, classes } = this.props;

    if (isLoading) {
      return <LoadingIndicator />;
    }
    return (
      <Button
        onClick={this.login}
        label="Login"
        color="primary"
        variant="contained"
        className={classes.buttonStyle}
      />
    );
  }

  render() {
    const {
      classes, inApp, logo, mail, telnr, copyrightBy, forgotPassword, customNotification, backgroundImage, errorMessage,
    } = this.props;
    const { userName, password } = this.state;

    if (inApp) {
      return null;
    }

    return (
      <div
        style={{
          backgroundImage: `url('${backgroundImage}'`,
          backgroundRepeat: 'no-repeat',
          backgroundAttachment: 'fixed',
          backgroundSize: 'cover',
          height: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Paper className={classes.containerStyle} onKeyPress={this.keyPress}>
          <form noValidate>
            <img className={classes.logoStyle} src={logo} alt="Logo" />
            <ErrorMessage errorMessage={errorMessage} />
            <div
              className={classes.formGroupStyle}
              style={{
                marginTop: 15,
              }}
            >
              <TextField
                autoFocus
                required
                fullWidth
                className={classes.inputStyle}
                placeholder="Username"
                value={userName}
                onChange={this.setUsername}
                autoComplete="username"
                InputProps={{
                  classes: {
                    input: classes.textfield,
                  },
                }}
              />
            </div>
            <div className={classes.formGroupStyle}>
              <PasswordField
                required
                fullWidth
                className={classes.inputStyle}
                placeholder="Passwort"
                value={password}
                onChange={this.setPassword}
                autoComplete="password"
              />
            </div>
            <div
              className={classes.formGroupStyle}
              style={{
                marginTop: 40,
                paddingBottom: 45,
              }}
            >
              {this.renderLoginButton()}
              {forgotPassword}
            </div>
          </form>
          <div>
            { mail
            && <a href={`mailto:${mail}`} className={classes.link}>{mail}</a>
            }

            <span>
              { mail && telnr
              && ' | '
              }
              { telnr }
            </span>
          </div>
          <div className={classes.copyrightStyle}>
            ©
            {' '}
            {copyrightBy}
            {' '}
            {new Date().getFullYear()}
          </div>
          {customNotification}
        </Paper>
      </div>
    );
  }
}


PictureLogin.propTypes = {
  login: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  inApp: PropTypes.bool,
  isLoading: PropTypes.bool,
  errorMessage: PropTypes.string,
  logo: PropTypes.string.isRequired,
  mail: PropTypes.string,
  telnr: PropTypes.string,
  copyrightBy: PropTypes.string.isRequired,
  forgotPassword: PropTypes.element,
  customNotification: PropTypes.element,
  backgroundImage: PropTypes.string.isRequired,
};

PictureLogin.defaultProps = {
  isLoading: false,
  errorMessage: null,
  inApp: false,
  mail: null,
  telnr: null,
  forgotPassword: null,
  customNotification: null,
};

export default withStyles(styles)(PictureLogin);
